export default "__VITE_ASSET__j7$IQuHh__"